export const DELETION_UNCONFIRMED = "Couldn't confirm deletion. Refresh the list before retrying.";
/** An OK HTTP status is not an acknowledgement of the selected issue IDs. */
export function readIssueDeletionResult(value, requestedIds) {
    const data = value;
    const ids = new Set(requestedIds);
    const readIds = (value) => {
        if (!Array.isArray(value) || value.some(id => typeof id !== 'string' || !ids.has(id))) {
            throw new Error(DELETION_UNCONFIRMED);
        }
        return [...new Set(value)];
    };
    const success = readIds(data?.success);
    const failed = readIds(data?.failed);
    const notFound = readIds(data?.notFound ?? []);
    if (success.some(id => failed.includes(id)) || notFound.some(id => !failed.includes(id))
        || new Set([...success, ...failed]).size !== ids.size) {
        throw new Error(DELETION_UNCONFIRMED);
    }
    return { success, failed, notFound };
}
export function deletingIssuesMessage(count) {
    return `Deleting ${count} issue${count === 1 ? '' : 's'}...`;
}
export function issueDeletionOutcome(result) {
    const alreadyGone = new Set(result.notFound);
    const failed = result.failed.filter(id => !alreadyGone.has(id));
    const removed = [...result.success, ...result.notFound];
    const parts = [];
    if (failed.length || (result.success.length && alreadyGone.size)) {
        parts.push(`${result.success.length} deleted`);
        if (alreadyGone.size)
            parts.push(`${alreadyGone.size} already deleted`);
        if (failed.length)
            parts.push(`${failed.length} failed`);
    }
    else if (alreadyGone.size) {
        parts.push(`${alreadyGone.size} issue${alreadyGone.size === 1 ? ' was' : 's were'} already deleted`);
    }
    else {
        parts.push(`${result.success.length} issue${result.success.length === 1 ? '' : 's'} deleted`);
    }
    const tone = failed.length ? 'error' : result.success.length ? 'success' : 'info';
    return { removed, failed, message: `${parts.join(', ')}.`, tone };
}
//# sourceMappingURL=issueDeletion.js.map